module.exports = __webpack_public_path__ + "img/TECNOLOGIA-CIAZ-3.eedab9df.jpg";